import React from 'react';
import Lottie from 'lottie-react';
import { LottieLoadingJSON } from '../../@theme/assets/lottie';
var Loader = function Loader() {
  return React.createElement(Lottie, {
    animationData: LottieLoadingJSON
  });
};
export default Loader;